
import {css} from "lit"
import {nap, repeat} from "@e280/stz"

import {view} from "../../../views/view.js"
import {Content} from "../../../views/types.js"
import {cssReset} from "../../../views/css-reset.js"

export function makeAsciiAnim(hz: number, frames: string[]): () => Content {
	return () => AsciiAnim({hz, frames})
}

export const AsciiAnim = view(use => ({hz, frames}: {
		hz: number,
		frames: string[],
	}) => {

	use.name("loading")
	use.styles(cssReset, style)
	const frame = use.signal(0)

	use.mount(() => repeat(async() => {
		await nap(1000 / hz)
		const next = frame() + 1
		frame(next >= frames.length ? 0 : next)
	}))

	return frames.at(frame())
})

const style = css`
:host {
	font-family: monospace;
	white-space: pre;
	user-select: none;
}
`

